import { useCallback, useState, type ReactNode } from 'react';
import { SidebarProvider } from '@/components/ui/sidebar';
import { SIDEBAR_COOKIE_NAME } from '@/components/ui/sidebar/constants';
import { SidebarCollapseRequestContext } from './sidebarCollapseRequest';

const SIDEBAR_COOKIE_PATTERN = new RegExp(`${SIDEBAR_COOKIE_NAME}=(true|false)`);
const OPEN_COOKIE_VALUE = 'true';

function getSidebarState(): boolean {
  const match = SIDEBAR_COOKIE_PATTERN.exec(document.cookie);
  return match ? match[1] === OPEN_COOKIE_VALUE : true;
}

interface AppSidebarProviderProps {
  children: ReactNode;
}

export function AppSidebarProvider({ children }: AppSidebarProviderProps) {
  const [isPreferredOpen, setIsPreferredOpen] = useState(getSidebarState);
  const [collapseRequestCount, setCollapseRequestCount] = useState(0);

  const requestSidebarCollapse = useCallback(() => {
    setCollapseRequestCount((count) => count + 1);
    return () => setCollapseRequestCount((count) => Math.max(0, count - 1));
  }, []);

  function handleOpenChange(isOpen: boolean) {
    setIsPreferredOpen(isOpen);
    setCollapseRequestCount(0);
  }

  return (
    <SidebarCollapseRequestContext.Provider value={requestSidebarCollapse}>
      <SidebarProvider
        open={isPreferredOpen && collapseRequestCount === 0}
        onOpenChange={handleOpenChange}
      >
        {children}
      </SidebarProvider>
    </SidebarCollapseRequestContext.Provider>
  );
}
